import React from 'react'
let total = 0,price = 0, total_d = 0;
let vector = ['1'];
let validate_count = 1;
let countLine = 1,countBrand=1,countCategory = 1;

const Products = function products ({products,lines,categoriesT,brandsT}){
    return (
    <section className="sliderProducts">
        <h2>Productos Destacados</h2>
        <div className="featured w80 dnone">
            <a>Nuevo</a>
            <a>Destacados</a>
            <a>Ofertas</a>
            <a>Todos</a>
        </div>
        <div className="container w90 relative">
        <img src="/img/backY.svg" alt="back" className="backY absolute"/>
        <img src="/img/nextY.svg" alt="next" className="nextY absolute"/>
        {vector.map((v) => {
            if (products.length > 0 && validate_count == 1) {
                validate_count = 2;
                setTimeout(function (){
                    $('#slickProducts').slick({
                        dots: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        prevArrow: '.backY',
                        nextArrow: '.nextY',
                        responsive: [
                          {
                            breakpoint: 1500,
                            settings: {
                              slidesToShow: 3,
                              slidesToScroll: 3,
                            }
                          },
                          {
                            breakpoint: 800,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 2,
                              arrows: false,
                            }
                          },
                          {
                            breakpoint: 455,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                            }
                          },
                        ]
                    });
                },100);
            }
        })}
        <div className="slickProducts" id="slickProducts">
                {products.map((p)=>
                    {
                        countLine = 1;
                        if(p.descount > 0){
                            total = new Intl.NumberFormat().format(p.price);
                            total = total.replace(/,/g , ".");
                            price = (p.price - (p.price * p.descount / 100));
                            total_d = new Intl.NumberFormat().format(price);
                            total_d = total_d.replace(/,/g , ".");
                            return(
                                <a href={https+'product/'+p.id} className="item" key={p.id}>
                                    <div className="colflex">
                                        <div className='img'>
                                            <div>
                                                <img src={https+p.img} alt="item"/>
                                            </div>
                                        </div> 
                                        <p>{p.name}</p>
                                        {brandsT.map((b)=>
                                        {
                                            if(b.id == p.brand_id){
                                                countBrand = 2;
                                                return <p className='p_2'>{b.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countBrand == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {categoriesT.map((c)=>
                                        {
                                            if(c.id == p.category_id){
                                                countCategory = 2;
                                                return <p className='p_2'>{c.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countCategory == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {lines.map((l)=>
                                        {
                                            if(l.id == p.line_id){
                                                countLine = 2;
                                                return <p className='p_2'>{l.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countLine == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        <span className="price">${total}</span>
                                        <div className="flex">
                                        <h4 className="offer">${total_d}</h4>
                                        <h5 className="discount">{p.descount}% OFF</h5>
                                        </div>
                                    </div>
                                </a>
                            )
                        }else{
                            total = new Intl.NumberFormat().format(p.price);
                            total = total.replace(/,/g , ".");
                            return(
                                <a href={https+'product/'+p.id} className="item" key={p.id}>
                                    <div className="colflex">
                                        <div className='img'>
                                            <div>
                                                <img src={https+p.img} alt="item"/>
                                            </div>
                                        </div>
                                        <p>{p.name}</p>
                                        {brandsT.map((b)=>
                                        {
                                            if(b.id == p.brand_id){
                                                countBrand = 2;
                                                return <p className='p_2'>{b.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countBrand == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {categoriesT.map((c)=>
                                        {
                                            if(c.id == p.category_id){
                                                countCategory = 2;
                                                return <p className='p_2'>{c.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countCategory == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {lines.map((l)=>
                                        {
                                            if(l.id == p.line_id){
                                                countLine = 2;
                                                return <p className='p_2'>{l.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countLine == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        <span className="price">&nbsp;</span>
                                        <div className="flex">
                                            <h4 className="offer">${total}</h4>
                                            <h5 className="discount"></h5>
                                        </div>
                                    </div>
                                </a>
                            )
                        }
                    }
                )}
            </div>
            <div className="btnToShop flex">
            <a href={https+'shop'}>Ver Tienda</a>
            </div>
        </div>
    </section>
)
}

export default Products